import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "planTypeRadio",
    "planTypeButton",
    "selectField",
    "dynamicFields",
    "recurringTemplate",
    "oneTimeTemplate",
    "creditPackTemplate",
    "weeklyLimitSection",
  ];

  connect() {
    if (this.element.dataset.planFormEditValue === "true") {
      const planType = this.element.dataset.planFormPlanTypeValue;
      if (planType) {
        if (planType === "recurring") {
          this.showRecurringFields();
        } else if (planType === "one_time") {
          this.showOneTimeFields();
        } else if (planType === "credit_pack") {
          this.showCreditPackFields();
        }
        this.updateWeeklyLimitVisibility();
        this.updateButtonStates();
      }
    } else {
      this.clearDynamicFields();
    }
  }

  togglePlanType(event) {
    this.updateFormFields();
  }

  selectPlanType(event) {
    const planType = event.currentTarget.dataset.planType;
    const radioButton = this.element.querySelector(
      `input[value="${planType}"]`
    );
    if (radioButton) {
      radioButton.checked = true;
      radioButton.dispatchEvent(new Event("change"));
    }

    // Update button visual states
    this.updateButtonStates();
  }

  updateButtonStates() {
    const selectedPlanType = this.getSelectedPlanType();

    this.planTypeButtonTargets.forEach((button) => {
      const buttonPlanType = button.dataset.planType;
      const isSelected = selectedPlanType === buttonPlanType;

      if (isSelected) {
        button.classList.remove(
          "bg-white",
          "dark:bg-gray-800",
          "text-gray-700",
          "dark:text-gray-300",
          "border-transparent",
          "font-normal"
        );
        button.classList.add(
          "bg-gray-100",
          "dark:bg-gray-700",
          "text-gray-900",
          "dark:text-white",
          "border-transparent",
          "font-bold"
        );
      } else {
        button.classList.remove(
          "bg-gray-100",
          "dark:bg-gray-700",
          "text-gray-900",
          "dark:text-white",
          "border-transparent",
          "font-bold"
        );
        button.classList.add(
          "bg-white",
          "dark:bg-gray-800",
          "text-gray-700",
          "dark:text-gray-300",
          "border-transparent",
          "font-normal"
        );
      }
    });
  }

  updateFormFields() {
    const selectedPlanType = this.getSelectedPlanType();

    // Update button visual states
    this.updateButtonStates();

    // Clear existing dynamic fields
    this.clearDynamicFields();

    if (selectedPlanType) {
      if (selectedPlanType === "recurring") {
        this.showRecurringFields();
      } else if (selectedPlanType === "one_time") {
        this.showOneTimeFields();
      } else if (selectedPlanType === "credit_pack") {
        this.showCreditPackFields();
      }
      this.updateWeeklyLimitVisibility();
    }
  }

  clearDynamicFields() {
    this.dynamicFieldsTarget.innerHTML = "";
  }

  getSelectedPlanType() {
    const checkedRadio = this.element.querySelector(
      'input[name*="plan_type"]:checked'
    );
    return checkedRadio ? checkedRadio.value : null;
  }

  showRecurringFields() {
    if (this.hasRecurringTemplateTarget) {
      const template = this.recurringTemplateTarget.content.cloneNode(true);
      this.dynamicFieldsTarget.appendChild(template);
    }
  }

  showOneTimeFields() {
    if (this.hasOneTimeTemplateTarget) {
      const template = this.oneTimeTemplateTarget.content.cloneNode(true);
      this.dynamicFieldsTarget.appendChild(template);
    }
  }

  showCreditPackFields() {
    if (this.hasCreditPackTemplateTarget) {
      const template = this.creditPackTemplateTarget.content.cloneNode(true);
      this.dynamicFieldsTarget.appendChild(template);
    }
  }

  updateWeeklyLimitVisibility() {
    if (this.hasWeeklyLimitSectionTarget) {
      const selectedPlanType = this.getSelectedPlanType();
      if (selectedPlanType === "credit_pack") {
        this.weeklyLimitSectionTarget.classList.add("hidden");
      } else {
        this.weeklyLimitSectionTarget.classList.remove("hidden");
      }
    }
  }
}
